import MyChannelView from '@/views/MyChannel';

/**
 * MyChannel Page - Simple wrapper for MyChannelView
 * All business logic and UI are in @/views/MyChannel
 */
export default function MyChannelPage() {
  return <MyChannelView />;
}
